import { FC, SetStateAction, useEffect } from 'react';
import { Button, HStack, Input, useNumberInput } from '@chakra-ui/react';

type Props = {
  setAmounts: SetStateAction<any>;
  position: number;
};

const NumberInput: FC<Props> = ({ setAmounts, position }) => {
  const {
    getInputProps,
    getIncrementButtonProps,
    getDecrementButtonProps,
    valueAsNumber
  } = useNumberInput({
    step: 1,
    min: 0,
    precision: 0,
    focusInputOnChange: false
  });

  useEffect(() => {
    setAmounts(position, valueAsNumber || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueAsNumber, position]);

  const inc = getIncrementButtonProps();
  const dec = getDecrementButtonProps();
  const input = getInputProps();

  const buttonProps = {
    size: 'sm',
    variant: 'ghost',
    bg: 'gray.800',
  };

  return (
    <HStack maxW='140px'>
      <Button {...dec} {...buttonProps}>
        -
      </Button>
      <Input
        {...input}
        borderRadius='xl'
        size='sm'
        placeholder='0'
        textAlign='center'
        minW='60px'
      />
      <Button {...inc} {...buttonProps} size='sm' variant='ghost'>
        +
      </Button>
    </HStack>
  );
};

export default NumberInput;
